// extracted by mini-css-extract-plugin
module.exports = {"atmosphericHeader":"index_atmosphericHeader_39Vr0","content":"index_content_PXl7p","image":"index_image_1fh_T"};